/** Roles allowed to use Developer Console (must stay aligned with DEVELOPER_CONSOLE_ALLOWED_ROLES on the API). */
const DEVELOPER_CONSOLE_ROLES = new Set(["owner", "company_admin", "super_admin"]);

export function canAccessDeveloperConsole(role: string | undefined): boolean {
  if (!role) return false;
  return DEVELOPER_CONSOLE_ROLES.has(role);
}

/** Revoke / reactivate applications (aligned with APPLICATION_LIFECYCLE_ROLES on the API). */
export function canManageApplicationLifecycle(role: string | undefined): boolean {
  return canAccessDeveloperConsole(role);
}
